module.exports = __webpack_public_path__ + "media/customizations/verandaliving/logo-new-fbf5e4e36ef97b95183dc27752122de2.png";